var render = function render() {
  var _vm$dataFrom$qrConfig;
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("查看二维码"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 620
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "customerId",
      label: _vm.$t("发布客户")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("发布客户"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.dropDownSearch,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.getQrcodeTemplateFun
    },
    model: {
      value: _vm.dataFrom.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerId", $$v);
      },
      expression: "dataFrom.customerId"
    }
  }, _vm._l(_vm.customerArr, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name))])], 1);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "qrConfigIds",
      label: _vm.$t("二维码模版")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      width: "100%"
    }
  }, [_c("a-select", {
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      placeholder: _vm.$t("请选择") + _vm.$t("二维码模版"),
      "show-search": "",
      "option-filter-prop": "label",
      mode: "multiple"
    },
    on: {
      change: _vm.qrConfigChange
    },
    model: {
      value: _vm.dataFrom.qrConfigIds,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "qrConfigIds", $$v);
      },
      expression: "dataFrom.qrConfigIds"
    }
  }, _vm._l(_vm.templateList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.customerInsuranceName + item.name
      }
    }, [_vm._v(_vm._s(item.customerInsuranceName) + "-" + _vm._s(item.name))]);
  }), 1)], 1)]), ((_vm$dataFrom$qrConfig = _vm.dataFrom.qrConfigIds) === null || _vm$dataFrom$qrConfig === void 0 ? void 0 : _vm$dataFrom$qrConfig.length) > 1 ? _c("a-form-model-item", {
    attrs: {
      prop: "productListPageId",
      label: _vm.$t("产品列表模版"),
      required: ""
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      width: "100%"
    }
  }, [_c("a-select", {
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      placeholder: _vm.$t("请选择") + _vm.$t("产品列表模版"),
      "show-search": ""
    },
    model: {
      value: _vm.dataFrom.productListPageId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "productListPageId", $$v);
      },
      expression: "dataFrom.productListPageId"
    }
  }, _vm._l(_vm.productList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.dataFrom.productListPageId ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.productListPreviewFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("模板预览")) + " ")]) : _vm._e()], 1)]) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      prop: "structureId",
      label: _vm.$t("部门")
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterTreeNode: _vm.filterTreeOption,
      "show-search": "",
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      placeholder: _vm.dataFrom.qrConfigIds ? _vm.$t("请选择") + _vm.$t("部门") : _vm.$t("请先选择二维码模版再选择部门"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      "replace-fields": {
        children: "children",
        key: "id",
        value: "id",
        title: "name"
      },
      disabled: _vm.structureIdDisable
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.dataFrom.structureId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "structureId", $$v);
      },
      expression: "dataFrom.structureId"
    }
  }), _c("div", {
    staticClass: "des"
  }, [_vm._v("* " + _vm._s(_vm.$t("选择渠道后，通过二维码产生的数据都会计入所选部门下")))])], 1), _c("a-form-model-item", {
    attrs: {
      prop: "userIds",
      label: _vm.$t("账号")
    }
  }, [_c("a-select", {
    ref: "accountRef",
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode,
      placeholder: _vm.dataFrom.structureId != undefined ? _vm.$t("请选择") + _vm.$t("账号") : _vm.$t("请先选择部门再选择账号"),
      mode: "multiple",
      "filter-option": _vm.dropDownSearchNo,
      disabled: _vm.dataFrom.structureId != undefined ? false : true
    },
    on: {
      change: _vm.accountChange
    },
    model: {
      value: _vm.userIds,
      callback: function ($$v) {
        _vm.userIds = $$v;
      },
      expression: "userIds"
    }
  }, _vm._l(_vm.accountList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.nickName) + "/" + _vm._s(item.account))]);
  }), 1), _c("div", {
    staticClass: "des"
  }, [_vm._v("* " + _vm._s(_vm.$t("选择账号后，通过二维码产生的数据都会计入所选账号下")))])], 1), _vm.link ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("链接")
    }
  }, [_c("a-input", {
    attrs: {
      "default-value": _vm.link,
      readOnly: true
    }
  }, [_c("div", {
    attrs: {
      slot: "addonAfter"
    },
    on: {
      click: _vm.clickCopyFun
    },
    slot: "addonAfter"
  }, [_vm._v(" " + _vm._s(_vm.$t("复制链接")) + " ")])])], 1) : _vm._e(), _vm.btnShow ? _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 5
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.downloadFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("生成出单二维码并下载")) + " ")])], 1) : _vm._e()], 1), _vm.productListPreviewShow ? _c("product-list-preview", {
    ref: "productListPreviewRef",
    on: {
      cancel: function ($event) {
        _vm.productListPreviewShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };